import {UmpireImage} from '../umpire-image';
import {Language} from '../umpire-language-service';
import {UmpireOttAvailability} from '../umpire-ott-availability';
import {UmpireOttEvent} from '../umpire-ott-event';
import {UmpireOttSegment} from '../umpire-ott-segment';
import {UmpirePublicationOptions} from '../umpire-publication-options';
import {UmpireTag} from '../umpire-tag';

export class UmpireOttFormat implements UmpirePublicationOptions {
  name!: string;

  availability!: UmpireOttAvailability;

  description!: string;

  teaser_copy!: string;

  author!: string;

  events_count?: number;

  type!: 'format';

  id!: string;

  slug!: string | null;

  image!: UmpireImage;

  image_vertical!: UmpireImage;

  image_horizontal!: UmpireImage;

  tags!: UmpireTag[];

  segments!: UmpireOttSegment[];

  segments_order!: SegmentOrder[];

  publication_time!: string | null;

  published_at!: string | null;

  is_draft!: boolean;

  events?: UmpireOttEvent[];

  locale!: Language;

  available_translations!: Language[];

  ads_enabled!: boolean;
}

export interface SegmentOrder {
  segment_id: string;
  segment_index: number;
}
